import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: "/Home",
  },
  {
    path: "/Home",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/Profile",
    name: "Profile",
    component: () => import("@/views/Profile.vue"),
  },
  {
    path: "/Project",
    name: "Project",
    component: () => import("@/views/Project.vue"),
  },
  {
    path: "/Resume",
    name: "Resume",
    component: () => import("@/views/Resume.vue"),
  },
  {
    path: "/Blog",
    name: "Blog",
    component: () => import("@/views/Blog.vue"),
  },
  {
    path: "/Blog/:slug",
    name: "BlogPost",
    component: () => import("@/views/BlogPost.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
